export default __webpack_public_path__ + "static/media/area.7c55991c.png";